import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

import LandingPage from '../pages/LandingPage'
import Recipe from '../pages/Recipe'
import Signin from '../pages/Signin'
import Signup from '../pages/Signup'
import Page404 from '../pages/Page404'
import LikedRecipes from '../pages/LikedRecipes'
import NewRecipe from '../pages/NewRecipe'
import Account from '../pages/Account'
import Searchpage from '../pages/SearchPage'

export default function AnimationRoutes() {
    /*const location = useLocation()*/
  return (
    <AnimatePresence mode='wait'>
        <Routes /*location={location} key={(location.pathname)}*/>
            <Route exact path="/" element={<LandingPage />} />
            <Route exact path="/search" element={<Searchpage />} />
            <Route path="/recipes-you-like/:id" element={<LikedRecipes />} />
            <Route path="/new-recipe/:id" element={<NewRecipe />} />
            <Route path="/recipe/:id" element={<Recipe />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/account/:id" element={<Account />} />
            <Route path="*" element={<Page404 />} />
        </Routes>
    </AnimatePresence>
  )
}
